// tag management data layer for consent
// get global for google tag manager
function getDataLayer() {
    return (window as any).dataLayer;
}

// get global for google analytics
function getGa() {
    return (window as any).ga;
}

export function trackCookiConsentEvent(isConsentGiven: boolean) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    if(isConsentGiven)
    {
        dataLayer.push({
            event: "consent_given",
        });
    }
    else
    {
        dataLayer.push({
            event: "consent_rejected",
        });
    }

}
